/* eslint-disable import/no-named-as-default-member */
import React, { Fragment } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Button, Grid, Fade, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Check, DoneAll, Apps } from "@material-ui/icons";
import LoanPrefTable from "../../../Global/TablePreferenceColumns/LoanPrefTable";
import LoanSeniorityTypes from "../../../../constants/loanSeniorityTypes";
import { getLoansByPreferenceAndLoanSeniority, getPipelineDealLoanCounts, downloadDealQuotes } from "../../../../store/state/loan/loan";
import { getScreenPreferences } from "../../../../shared-utility/store/state/screenPreferences";
import SeniorLoanTableColumns from "../../../Global/TablePreferenceColumns/LoanTableColumns/SeniorLoanTableColumns";
import MezzLoanTableColumns from "../../../Global/TablePreferenceColumns/LoanTableColumns/MezzLoanTableColumns";
import SupplementalLoanTableColumns from "../../../Global/TablePreferenceColumns/LoanTableColumns/SupplementalLoanTableColumns";
import numberFormatter from "../../../../utils/numberFormatter";
import guestPermissionHelper from "../../../../utils/guestPermissionHelper";
import SimpleConfirmDialog from "../../../Global/ConfirmationDialogs/SimpleConfirmDialog";
import dealStages from "../../../../constants/dealStages";
import {
  closeDeal,
  getWinningQuotes,
  cancelDealRefinance,
  cancelAddSupplemental,
  cancelModifyLoans,
  acknowledgeRedirect,
  clearReload,
  killDeal,
  reviveDeal
} from "../../../../store/state/deal";
import { SecondaryButton } from "../../../Global/Buttons";
import CloseDealRefiModal from "../../CloseRefiModal/CloseDealRefiModal";
import loanStatuses from "../../../../constants/loanStatuses";
import PickAWinnerModal from "../components/PickAWinnerModal";
import CombineQuotesModal from "./CombineQuotes/CombineQuotesModal";
import LoanProceedsModal from "components/Calculators/LoanProceeds/ModalForm";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import { AnalysisButton } from "./ActiveQuotesButtonBar";
import NoQuotes from "./NoQuotes";
import { TableButtonBar, Spacer } from "./styles";
import CompareLoansModal from "./CompareLoansModal";
import materialStyles from "../materialStyles";
import SubsectionTitle from "../components/SubsectionTitle";
import QuoteCombineCompareAnalysisModal from "./QuoteCombineCompareAnalysisModal";
import CompleteLoanModificationModal from "../../CompleteLoanModificationModal";
import RefiCompareLoansModal from "./RefiCompareLoansModal";
import dealStatuses from "../../../../constants/status";
import WhatIfModal from "components/Portfolio/WhatIfModal"

const DealStatusChangeActionContainer = styled(Grid)`
  height: 0px;
  position: relative;
  top: -118px;
  float: right;
  text-align: right !important;
`;

const DealStatusChangeActionButton = styled(Button)`
  &&& {
    margin-left: 4px;
    padding: 10px 15px 10px 15px;
    border-radius: 3px;
    border-width: 1px;
    border-style: solid;
    border-color: #2196f3;
    color: #2196f3;
    background: none;
  }
`;

const StyledHeaderButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    position: unset;
  }
  &&:hover {
    background: none;
  }
`;

const PickAWinnerButton = props => {
  if (props.isDead) {
    return <div style={{ display: "inline block", paddingTop: "7px", marginLeft: "10px", marginRight: "20px", ...props.style }}>DEAD</div>;
  }
  return (
    <>
      <DealStatusChangeActionButton onClick={props.onClick} style={props.style}>
        <Check />
        <span>PICK A WINNER</span>
      </DealStatusChangeActionButton>
    </>
  );
};

const CalculatorButton = props => {
  return (
    <StyledHeaderButton variant="contained" onClick={props.onClick} disableRipple={true}>
      <Apps />
      Analysis
    </StyledHeaderButton>
  );
};

const tabs = { SENIOR: 0, SUBORDINATE: 1, SUPPLEMENTAL: 2 };

class PipelineActiveDealQuotes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: tabs.SENIOR,
      shouldShowCompareLoansModal: false,
      shouldShowCombineLoansModal: false,
      shouldShowPickAWinnerModal: false,
      shouldShowAnalysisModal: false,
      shouldShowConfirmKillDialog: false,
      shouldShowReviveDialog: false,
      cancelRefiDialogOpen: false,
      cancelSupplementalDialogOpen: false,
      isCompareAndCombine: false,
      isLoanProceedsCalculatorOpen: false,
      isWhatIfCalculatorOpen: false
    };
  }

  componentDidMount() {
    const { dealId } = this.props;
    this.props.getPipelineDealLoanCounts({ dealId });
    const curriedSeniorQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_senior_loans", LoanSeniorityTypes.SENIOR);
    curriedSeniorQuery(0, 100);
    const curriedMezzQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_mezz_loans", LoanSeniorityTypes.SUBORDINATE);
    curriedMezzQuery(0, 100);
    const curriedSupplementalQuery = this.getLoansBySeniority(this.getComparableLoanColumns(),"comparable_supplemental_loans",LoanSeniorityTypes.SUPPLEMENTAL);
    curriedSupplementalQuery(0, 100);
    this.getPaginatedSenior(0, 10, "ASC");
    this.getPaginatedMezz(0, 10, "ASC");
    this.getPaginatedSupplemental(0, 10, "ASC");
  }

  static getDerivedStateFromProps(props, state) {
    const { seniorLoanCount, mezzLoanCount, deal } = props;
    const { previousSeniorLoanCount, previousMezzLoanCount, currentTab } = state;
    if (deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.ADDING_SUPPLEMENTAL) {
      state.currentTab = tabs.SUPPLEMENTAL;
    } else if (mezzLoanCount !== previousMezzLoanCount || seniorLoanCount !== previousSeniorLoanCount) {
      if (currentTab === tabs.SENIOR && seniorLoanCount === 0 && mezzLoanCount > 0) {
        state.currentTab = tabs.SUBORDINATE;
      } else if (currentTab === tabs.SUBORDINATE && mezzLoanCount === 0 && seniorLoanCount > 0) {
        state.currentTab = tabs.SENIOR;
      }
    }
    state.previousSeniorLoanCount = state.seniorLoanCount;
    state.previousMezzLoanCount = state.mezzLoanCount;
    state.seniorLoanCount = props.seniorLoanCount;
    state.mezzLoanCount = props.mezzLoanCount;
  }

  componentDidUpdate(prevProps) {
    const { dealId } = this.props;
    if (this.props.isExpired && prevProps.isExpired === false) {
      this.props.getPipelineDealLoanCounts({ dealId });
    }
    this.getScreenPreferencesIfCountChanged("senior_loan_table", this.props.seniorLoanCount, prevProps.seniorLoanCount);
    this.getScreenPreferencesIfCountChanged("mezz_loan_table", this.props.mezzLoanCount, prevProps.mezzLoanCount);
    this.getScreenPreferencesIfCountChanged("supplemental_loan_table", this.props.supplementalLoanCount, prevProps.supplementalLoanCount);
    this.getScreenPreferencesIfCountChanged("senior_loan_table", this.props.supplementalLoanCount, prevProps.supplementalLoanCount);
    if (this.props.reload) {
      this.props.clearReload();
      window.location.reload(false);
    }
    if (this.props.redirectTo) {
      this.props.acknowledgeRedirect();
      this.props.history.push(this.props.redirectTo);
    }
  }

  getScreenPreferencesIfCountChanged = (screenType, current, prev) => {
    if (current !== prev) {
      this.props.getScreenPreferences({
        screenType
      });
    }
  };

  getComparableLoanColumns = () => {
    return ["amount", "loanTermMonths", "rateTypeId"];
  };

  getSeniorPreferenceColumns = () => {
    return this.getPreferenceColumns("seniorPrefs", SeniorLoanTableColumns);
  };

  getMezzPreferenceColumns = () => {
    return this.getPreferenceColumns("mezzPrefs", MezzLoanTableColumns);
  };

  getSupplementalPreferenceColumns = () => {
    return this.getPreferenceColumns("supplementalPrefs", SupplementalLoanTableColumns);
  };

  getPreferenceColumns = (prefPropName, columnDefinitions) => {
    const prefs = this.props[prefPropName];
    if (prefs) {
      const prefElementIds = prefs.map(x => x.screenElementId);
      return columnDefinitions.filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id)).map(x => x.dataField);
    }
    return undefined;
  };

  refreshGridCallback = () => {
    this.handleSeniorTabChange();
    this.handleMezzTabChange();
    this.handleSupplementalTabChange();
    this.props.refreshGridCallback();
  };

  getPaginatedSenior = (page, pageSize, sortOrder) => {
    const desiredColumns = this.getSeniorPreferenceColumns();
    const curriedQuery = this.getLoansBySeniority(desiredColumns, "senior_loan_table", LoanSeniorityTypes.SENIOR);
    curriedQuery(page, pageSize, sortOrder);
  };

  getPaginatedMezz = (page, pageSize, sortOrder) => {
    const desiredColumns = this.getMezzPreferenceColumns();
    const curriedQuery = this.getLoansBySeniority(desiredColumns, "mezz_loan_table", LoanSeniorityTypes.SUBORDINATE);
    curriedQuery(page, pageSize, sortOrder);
  };

  getPaginatedSupplemental = (page, pageSize, sortOrder) => {
    const desiredColumns = this.getSupplementalPreferenceColumns();
    const curriedQuery = this.getLoansBySeniority(desiredColumns, "supplemental_loan_table", LoanSeniorityTypes.SUPPLEMENTAL);
    curriedQuery(page, pageSize, sortOrder);
  };

  getLoansBySeniority = (desiredColumns, subKey, loanSeniorityId) => {
    const { dealId } = this.props;
    return (page, pageSize, sortOrder) => {
      this.props.getLoansByPreferenceAndLoanSeniority({
        subKey,
        dealId,
        loanSeniorityId,
        columns: desiredColumns,
        page,
        pageSize,
        sortOrder,
        includePassedRejected: this.props.authentication.isGuest && !this.props.guestPermissions.pipelineAllowQuoteStatus
      });
    };
  };

  toggleQuotes = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }));
  };

  handleSeniorTabChange = () => {
    this.props.getScreenPreferences({ screenType: "senior_loan_table" });
    const curriedQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_senior_loans", LoanSeniorityTypes.SENIOR);
    curriedQuery(0, 100);
  };

  handleMezzTabChange = () => {
    this.props.getScreenPreferences({ screenType: "mezz_loan_table" });
    const curriedQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_mezz_loans", LoanSeniorityTypes.SUBORDINATE);
    curriedQuery(0, 100);
  };

  handleSupplementalTabChange = () => {
    this.props.getScreenPreferences({ screenType: "supplemental_loan_table" });
    this.props.getScreenPreferences({ screenType: "senior_loan_table" });
    const curriedQuery = this.getLoansBySeniority(this.getComparableLoanColumns(), "comparable_supplemental_loans", LoanSeniorityTypes.SUPPLEMENTAL);
    curriedQuery(0, 100);
  };

  handleTabChange = (_event, value) => {
    this.setState({ currentTab: value });
    if (this.props.deal.dealStatusId !== dealStatuses.ADDING_SUPPLEMENTAL) {
      if (value === tabs.SENIOR) {
        this.handleSeniorTabChange();
      } else if (value === tabs.SUBORDINATE) {
        this.handleMezzTabChange();
      } else {
        throw new Error(`Invalid tab index ${value} or deal status ${this.props.deal.dealStatusId}`);
      }
    }
  };

  showCompare = () => {
    this.setState({
      shouldShowCompareLoansModal: true
    });
  };

  showCombine = isCompareAndCombine => {
    this.setState({
      shouldShowCombineLoansModal: true,
      isCompareAndCombine: !!isCompareAndCombine
    });
  };

  showAnalysisModal = () => {
    this.setState({
      shouldShowAnalysisModal: true
    });
  };

  closeAnalysisModal = () => {
    this.setState({
      shouldShowAnalysisModal: false
    });
  };

  showPickAWinner = () => {
    this.setState({
      shouldShowPickAWinnerModal: true
    });
  };

  getTabType = tab => {
    switch (tab) {
      case tabs.SENIOR:
        return "Senior";
      case tabs.SUBORDINATE:
        return "Subordinate";
      case tabs.SUPPLEMENTAL:
        return "Supplemental";
      default:
        throw new Error(`Invalid tab: ${tab}`);
    }
  };

  getLoanTermYears = loan => {
    const { loanTermMonths } = loan;
    if (loanTermMonths) return `${(loanTermMonths / 12).toFixed(2)} Years`;
    return "N/A";
  };

  getInterestRateType = loan => {
    return _.get(loan, "rateTypeRef.name") || "N/A";
  };

  getLoanAmount = loan => {
    return numberFormatter.maskCurrency(loan.amount) || "N/A";
  };

  formatForCompare = loan => {
    return {
      id: loan.id,
      status: loan.loanStatusId,
      title: `${loan["lenderCompany.name"] || _.get(loan, "loanCompanyBridge[0].company.name") || "N/A"} | ${this.getLoanTermYears(
        loan
      )} | ${this.getInterestRateType(loan)} | ${this.getLoanAmount(loan)}`
    };
  };

  formatForWhatIf = loan => {
    return {
      id: loan.id,
      label: `${loan["lenderCompany.name"] || _.get(loan, "loanCompanyBridge[0].company.name") || "N/A"} | ${this.getLoanTermYears(
        loan
      )} | ${this.getInterestRateType(loan)} | ${this.getLoanAmount(loan)}`
    };
  };


  getLoanData = key => {
    const loanData = this.props[key].data;
    if (loanData && loanData.loans) return loanData.loans;
    return [];
  };

  getActiveTabLoanData = tab => {
    switch (tab) {
      case tabs.SENIOR:
        return this.getLoanData("comparableSeniorLoans").map(this.formatForCompare);
      case tabs.SUBORDINATE:
        return this.getLoanData("comparableMezzLoans").map(this.formatForCompare);
      case tabs.SUPPLEMENTAL:
        return this.getLoanData("comparableSupplementalLoans").map(this.formatForCompare);
      default:
        throw new Error(`Invalid tab: ${tab}`);
    }
  };

  hasSeniorAndMezzLoans = () => {
    return this.props.seniorLoanCount > 0 && this.props.mezzLoanCount > 0;
  };

  downloadLoans = () => {
    const payload = {
      loanStatusIds: [loanStatuses.QUOTE, loanStatuses.REJECTED_QUOTE, loanStatuses.PASSED_QUOTE],
      dealId: this.props.dealId
    };
    this.props.downloadDealQuotes(payload);
  };

  renderCloseDealReminderDialog() {
    return (
      <SimpleConfirmDialog
        title="Reminder"
        message={(
          <div>
            Please send all relevant loan and property documents to <a href="mailto:onboarding@loanboss.com">LoanBoss</a>.
          </div>
        )}
        yesText="OK"
        modalOpen={this.state.isCloseDealReminderDialogOpen}
        handleYes={() => {
          this.setState({ isCloseDealReminderDialogOpen: false, redirectToPortfolio: true });
        }}
      />
    );
  }

  renderCompleteModifyLoansModal = () => {
    if (!this.state.showCompleteModifyLoansModal) {
      return null;
    }

    return <CompleteLoanModificationModal dealId={this.props.deal.id} onClose={() => this.setState({ showCompleteModifyLoansModal: false })} />;
  };

  renderCloseDealDialog() {
    if (!this.state.isConfirmCloseDealDialogOpen) {
      return null;
    }
    if (!this.props.dealMap.winningQuotes || this.props.dealMap.winningQuotes.length === 0) {
      this.props.getWinningQuotes(this.props.dealId);
    }
    let seniorWinningQuote;
    let subordinateWinningQuote;
    let supplementalWinningQuote;
    if (this.props.dealMap.winningQuotes) {
      const seniorWinningQuotes = this.props.dealMap.winningQuotes.filter(loan => loan.loanSeniorityId === LoanSeniorityTypes.SENIOR);
      if (seniorWinningQuotes.length === 1) {
        seniorWinningQuote = this.formatForCompare(seniorWinningQuotes[0]);
      }

      const subordinateWinningQuotes = this.props.dealMap.winningQuotes.filter(loan => loan.loanSeniorityId === LoanSeniorityTypes.SUBORDINATE);
      if (subordinateWinningQuotes.length === 1) {
        subordinateWinningQuote = this.formatForCompare(subordinateWinningQuotes[0]);
      }

      const supplementalWinningQuotes = this.props.dealMap.winningQuotes.filter(loan => loan.loanSeniorityId === LoanSeniorityTypes.SUPPLEMENTAL);
      if (supplementalWinningQuotes.length === 1) {
        supplementalWinningQuote = this.formatForCompare(supplementalWinningQuotes[0]);
      }
    }
    const deal = this.props.deal;
    if (deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.REFINANCE) {
      return (
        <CloseDealRefiModal
          history={this.props.history}
          dealId={deal.id}
          isOpen={this.state.isConfirmCloseDealDialogOpen}
          handleClose={() => this.setState({ isConfirmCloseDealDialogOpen: false })}
        />
      );
    }

    return (
      <SimpleConfirmDialog
        fullWidth
        maxWidth="md"
        title="Confirm Close"
        message={(
          <div>
            You are about to close this deal. This action can only be reverted by a <a href="mailto:support@loanboss.com">LoanBoss Administrator</a>.
            <br />
            <br />
            <div style={{ marginLeft: 30 }}>
              {seniorWinningQuote && (
                <>
                  <b>Senior Quote:</b> {seniorWinningQuote.title}
                  <br />
                </>
              )}
              {subordinateWinningQuote && (
                <>
                  <b>Subordinate Quote:</b> {subordinateWinningQuote.title}
                  <br />
                </>
              )}
              {supplementalWinningQuote && (
                <>
                  <b>Supplemental Quote:</b> {supplementalWinningQuote.title}
                  <br />
                </>
              )}
            </div>
            <br />
            Are you sure you want to do this?
            <br />
            <br />
            <b>NOTE:</b> All guests that have been added to this deal will be removed upon clicking &quot;Close Deal&quot;.
          </div>
        )}
        noText="CANCEL"
        yesText="CLOSE DEAL"
        modalOpen={this.state.isConfirmCloseDealDialogOpen}
        handleNo={() => this.setState({ isConfirmCloseDealDialogOpen: false })}
        handleYes={() => {
          this.props.closeDeal(this.props.dealId);
          this.setState({ isCloseDealReminderDialogOpen: true, isConfirmCloseDealDialogOpen: false });
        }}
      />
    );
  }

  hasSeniorLoansToDisplay = () => {
    const seniorLoanData = this.props.seniorLoanData;
    if (!seniorLoanData || !seniorLoanData.data || _.isEmpty(seniorLoanData.data) || _.isEmpty(seniorLoanData.data.loans)) {
      return false;
    }
    let found = false;
    seniorLoanData.data.loans.forEach(loan => {
      if (loan.loanStatusId === loanStatuses.QUOTE || loan.loanStatusId === loanStatuses.IN_CLOSING) {
        found = true;
      }
    });
    return found;
  };

  hasSubordinateLoansToDisplay = () => {
    const mezzLoanData = this.props.mezzLoanData;
    if (!mezzLoanData || !mezzLoanData.data || _.isEmpty(mezzLoanData.data) || _.isEmpty(mezzLoanData.data.loans)) {
      return false;
    }
    let found = false;
    mezzLoanData.data.loans.forEach(loan => {
      if (loan.loanStatusId === loanStatuses.QUOTE || loan.loanStatusId === loanStatuses.IN_CLOSING) {
        found = true;
      }
    });
    return found;
  };

  cancelRefiAndCloseRelatedModal = () => {
    this.setState({ cancelRefiDialogOpen: false });
    this.props.cancelDealRefinance({ dealId: this.props.dealId });
  };

  cancelSupplementalAndCloseRelatedModal = () => {
    this.setState({ cancelSupplementalDialogOpen: false });
    this.props.cancelAddSupplemental({ dealId: this.props.dealId });
  };

  showConfirmKillDialog = () => {
    this.setState({ shouldShowConfirmKillDialog: true });
  };

  hideConfirmKillDialog = () => {
    this.setState({ shouldShowConfirmKillDialog: false });
  };

  showReviveDialog = () => {
    this.setState({ shouldShowReviveDialog: true });
  };

  hideReviveDialog = () => {
    this.setState({ shouldShowReviveDialog: false });
  };

  killDeal = () => {
    this.props.deal.dealStatusId = dealStatuses.DEAD;
    this.props.deal.dealStatus = { id: dealStatuses.DEAD, value: "Dead" };
    this.props.killDeal({ dealId: this.props.dealId });
  };

  reviveDeal = () => {
    this.props.deal.dealStatusId = dealStatuses.PIPELINE;
    this.props.deal.dealStatus = { id: dealStatuses.PIPELINE, value: "Pipeline" };
    this.props.reviveDeal({ dealId: this.props.dealId });
  };

  buttonRenderer = (isMenuOpen, clickHandler) => {    
    return (
        <CalculatorButton onClick={clickHandler} disableRipple={true} />
    )
  }

  getCalculatorOptions = () => {
    return [
      {
        id: 1,
        value: "Compare / Combine",
        onClick: this.showAnalysisModal,
      }, 
      {
        id: 2,
        value: "Loan Proceeds Calculator",
        onClick: this.openLoanProceedsCalculator,
      }, 
      {
        id: 3,
        value: "What If (Beta)",
        onClick: this.openWhatIfCalculator,
      }, 
      
    ]
  }

  openLoanProceedsCalculator = () => {
    this.setState({
      isLoanProceedsCalculatorOpen: true,
    })
  }

  closeLoanProceedsCalculator = () => {
    this.setState({
      isLoanProceedsCalculatorOpen: false,
    })
  }
  
  openWhatIfCalculator = () => {
    this.setState({
      isWhatIfCalculatorOpen: true,
    })
  }

  closeWhatIfCalculator = () => {
    this.setState({
      isWhatIfCalculatorOpen: false,
    })
  }

  render() {
    const { currentTab, shouldShowCompareLoansModal, shouldShowCombineLoansModal, shouldShowPickAWinnerModal } = this.state;
    const {
      deal,
      classes,
      onExpired,
      isExpired,
      seniorPrefs,
      seniorLoanData,
      mezzPrefs,
      mezzLoanData,
      supplementalPrefs,
      supplementalLoanData,
      supplementalLoanCount,
      dealId,
      authentication,
      guestPermissions
    } = this.props;

    if (this.state.redirectToPortfolio) {
      return <Redirect to={`/portfolio/funds/free/deals/${dealId}`} />;
    }
    const tempSeniorLoanTableColumns = guestPermissionHelper.getTableColumns(guestPermissions, SeniorLoanTableColumns);
    const tempMezzLoanTableColumns = guestPermissionHelper.getTableColumns(guestPermissions, MezzLoanTableColumns);
    const tempSupplementalLoanTableColumns = guestPermissionHelper.getTableColumns(guestPermissions, SupplementalLoanTableColumns);
    const isDead = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.DEAD;
    let inClosing = !authentication.isGuest && deal.stageId === dealStages.IN_CLOSING;
    const isRefinance = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.REFINANCE;
    const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.ADDING_SUPPLEMENTAL;
    const isPipeline = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.PIPELINE;
    const isModifying = deal && deal.dealStatus && deal.dealStatus.id === dealStatuses.MODIFYING;

    if (isRefinance) {
      if (this.props.seniorLoanData && this.props.seniorLoanData.data && this.props.seniorLoanData.data.loans) {
        this.props.seniorLoanData.data.loans.forEach(quote => {
          if (quote.version === deal.version && quote.loanStatusId === loanStatuses.IN_CLOSING) {
            // in closing
            inClosing = true;
          }
        });
      }
    }
    return (
      <div style={{ marginTop:  authentication.isGuest || inClosing || isModifying ? "25px" : "-70px" }}>
        <SimpleConfirmDialog
          modalOpen={this.state.cancelRefiDialogOpen}
          handleNo={() => this.setState({ cancelRefiDialogOpen: false })}
          handleYes={this.cancelRefiAndCloseRelatedModal}
          title="Confirm Cancel Refinancing"
          message={`Are you sure you want to cancel refinancing? This will reject any pending quotes. 
        Your information will not be lost and you can access the quotes on your original Loans.`}
          noText="Cancel"
          yesText="Confirm"
        />
        <SimpleConfirmDialog
          modalOpen={this.state.cancelSupplementalDialogOpen}
          handleNo={() => this.setState({ cancelSupplementalDialogOpen: false })}
          handleYes={this.cancelSupplementalAndCloseRelatedModal}
          title="Confirm Cancel Supplemental"
          message={`Are you sure you want to cancel adding a supplemental loan? This will reject any pending quotes. 
        Your information will not be lost and you can access the quotes on your original Loans.`}
          noText="Cancel"
          yesText="Confirm"
        />
        <SimpleConfirmDialog
          modalOpen={this.state.shouldShowConfirmKillDialog}
          handleNo={this.hideConfirmKillDialog}
          handleYes={() => {
            this.killDeal();
            this.hideConfirmKillDialog();
            this.props.history.push("/pipeline/");
          }}
          title="Confirm Cancel"
          message="You are about to move this deal to Dead status. Are you sure you want to do this?"
          secondaryContent="Your information will not be lost and you can move it back to active in the future."
          noText="No"
          yesText="Yes, Cancel"
        />
        <SimpleConfirmDialog
          modalOpen={this.state.cancelModifyDialogOpen}
          handleNo={() => this.setState({ cancelModifyDialogOpen: false })}
          handleYes={() => {
            this.props.cancelModifyLoans(deal.id);
            this.setState({ cancelModifyDialogOpen: false });
          }}
          title="Confirm Cancel"
          message="You are about to cancel modifications for the loan(s) and all of your changes will be lost."
          secondaryContent="Are you sure you want to do this?"
          noText="No"
          yesText="Yes, Cancel"
        />
        <SimpleConfirmDialog
          modalOpen={this.state.shouldShowReviveDialog}
          handleNo={this.hideReviveDialog}
          handleYes={() => {
            this.reviveDeal();
            this.hideReviveDialog();
          }}
          title="Confirm Reactivate"
          message="You are about to move this deal to Pipeline status. Are you sure you want to do this?"
          noText="No"
          yesText="Yes, Confirm"
        />
        {this.renderCompleteModifyLoansModal()}        
        {!authentication.isGuest && !inClosing && (
          <Fragment style={{ verticalAlign: "middle", marginBottom: "0px", zIndex: 2 }}>
            {this.props.deal.dealStatus && !isModifying && <PickAWinnerButton isDead={isDead} onClick={this.showPickAWinner} style={{ float: "right" }} />}
            {isPipeline && (
              <SecondaryButton style={{ float: "right", paddingTop: "10px" }} onClick={this.showConfirmKillDialog}>
                Cancel Deal
              </SecondaryButton>
            )}
            {isDead && (
              <SecondaryButton style={{ float: "right", paddingTop: "10px" }} onClick={this.showReviveDialog}>
                Reactivate
              </SecondaryButton>
            )}
            {isRefinance && (
              <SecondaryButton
                style={{ float: "right", marginTop: "5px" }}
                onClick={() => {
                  const seniorLoans = this.props.seniorLoanData.data || { count: 1 }; // this is 1 because it may not have loaded in yet, in that case, stay on safe side and present confirm modal
                  const mezzLoans = this.props.mezzLoanData.data || { count: 0 };
                  const supplementalLoans = this.props.supplementalLoanData.data || { count: 0 };
                  if (seniorLoans.count > 0 || mezzLoans.count > 0 || supplementalLoans.count > 0) {
                    this.setState({ cancelRefiDialogOpen: true });
                  } else {
                    this.props.cancelDealRefinance({ dealId });
                  }
                }}
              >
                Cancel Refinancing
              </SecondaryButton>
            )}
            {isAddingSupplemental && (
              <SecondaryButton
                style={{ float: "right", marginTop: "5px" }}
                onClick={() => {
                  const supplementalLoans = this.props.supplementalLoanData.data || { count: 0 };
                  if (supplementalLoans.count > 0) {
                    this.setState({ cancelSupplementalDialogOpen: true });
                  } else {
                    this.props.cancelAddSupplemental({ dealId });
                  }
                }}
              >
                Cancel Supplemental
              </SecondaryButton>
            )}
          </Fragment>
        )}
        {!authentication.isGuest && inClosing && (
          <>
            <DealStatusChangeActionContainer>
              <div style={{ display: "flex" }}>
                <div style={{ verticalAlign: "center", margin: 10 }}>IN CLOSING</div>
                <DealStatusChangeActionButton onClick={() => this.setState({ isConfirmCloseDealDialogOpen: true })}>
                  <DoneAll />
                  <span>CLOSE THE DEAL</span>
                </DealStatusChangeActionButton>
              </div>
            </DealStatusChangeActionContainer>
          </>
        )}
        {!authentication.isGuest && deal.dealStatusId === dealStatuses.MODIFYING && (
          <>
            <DealStatusChangeActionContainer>
              <div style={{ display: "flex" }}>
                <SecondaryButton style={{ float: "right", marginTop: "5px" }} onClick={() => this.setState({ cancelModifyDialogOpen: true })}>
                  CANCEL MODIFY
                </SecondaryButton>
                <DealStatusChangeActionButton onClick={() => this.setState({ showCompleteModifyLoansModal: true })}>
                  <DoneAll />
                  <span>CONFIRM MODIFY</span>
                </DealStatusChangeActionButton>
              </div>
            </DealStatusChangeActionContainer>
          </>
        )}
        {deal.dealStatusId && deal.dealStatusId !== dealStatuses.MODIFYING && (
          <>
            <Grid container spacing={16}>
              <Grid item>
                <SubsectionTitle title="Active" />
              </Grid>
            </Grid>
            <TableButtonBar>
              {!isAddingSupplemental && (
                <Tabs value={currentTab} onChange={this.handleTabChange} classes={{ indicator: classes.tabsIndicator }}>
                  <Tab disableRipple value={tabs.SENIOR} label="Senior" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                  <Tab disableRipple value={tabs.SUBORDINATE} label="Subordinate" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                </Tabs>
              )}
              {isAddingSupplemental && (
                <Tabs value={currentTab} onChange={this.handleTabChange} classes={{ indicator: classes.tabsIndicator }}>
                  <Tab disableRipple value={tabs.SUPPLEMENTAL} label="Supplemental" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                </Tabs>
              )}

              <Spacer />
              <div>
                <OptionsMenu buttonRenderer={this.buttonRenderer} options={this.getCalculatorOptions()}/>
                {/* <AnalysisButton onClick={this.showAnalysisModal} /> */}
                
                <PickAWinnerModal
                  dealId={dealId}
                  onClose={() => this.setState({ shouldShowPickAWinnerModal: false })}
                  seniorLoans={this.getLoanData("comparableSeniorLoans").map(this.formatForCompare)}
                  mezzLoans={this.getLoanData("comparableMezzLoans").map(this.formatForCompare)}
                  supplementalLoans={this.getLoanData("comparableSupplementalLoans").map(this.formatForCompare)}
                  supplementalLoansOnly={isAddingSupplemental}
                  refreshGridCallback={this.refreshGridCallback}
                  isOpen={shouldShowPickAWinnerModal}
                />
                {this.renderCloseDealDialog()}
                {this.renderCloseDealReminderDialog()}
              </div>
            </TableButtonBar>
            {currentTab === tabs.SENIOR && (
              <>
                {this.hasSeniorLoansToDisplay() && (
                  <Fade in>
                    <Paper elevation={4}>
                      <LoanPrefTable
                        isExpired={isExpired}
                        setExpired={onExpired}
                        screenType="senior_loan_table"
                        tableScreenElements={tempSeniorLoanTableColumns}
                        shouldHideExport
                        screenPreferences={seniorPrefs}
                        getData={this.getPaginatedSenior}
                        tableData={seniorLoanData}
                        dealId={dealId}
                        downloadLoans={this.downloadLoans}
                        tableConfigItemId="b54c6c7a-231e-4a0f-8227-e7259838c335"
                      />
                    </Paper>
                  </Fade>
                )}
                {!this.hasSeniorLoansToDisplay() && (
                  <Fade in>
                    <Paper elevation={4}>
                      <NoQuotes />
                    </Paper>
                  </Fade>
                )}
              </>
            )}
            {currentTab === tabs.SUBORDINATE && (
              <>
                {this.hasSubordinateLoansToDisplay() && (
                  <Fade in>
                    <Paper elevation={4}>
                      <LoanPrefTable
                        isExpired={isExpired}
                        setExpired={onExpired}
                        screenType="mezz_loan_table"
                        shouldHideExport
                        tableScreenElements={tempMezzLoanTableColumns}
                        screenPreferences={mezzPrefs}
                        getData={this.getPaginatedMezz}
                        dealId={dealId}
                        tableData={mezzLoanData}
                        downloadLoans={this.downloadLoans}
                        tableConfigItemId="4643f8c8-a348-46d8-aa35-6a5fc3a43108"
                      />
                    </Paper>
                  </Fade>
                )}
                {!this.hasSubordinateLoansToDisplay() && (
                  <Fade in>
                    <Paper elevation={4}>
                      <NoQuotes />
                    </Paper>
                  </Fade>
                )}
              </>
            )}
            {currentTab === tabs.SUPPLEMENTAL && (
              <>
                {supplementalLoanCount > 0 && (
                  <Fade in={supplementalLoanData.data !== null}>
                    <Paper elevation={4}>
                      <LoanPrefTable
                        isExpired={isExpired}
                        setExpired={onExpired}
                        screenType="supplemental_loan_table"
                        tableScreenElements={tempSupplementalLoanTableColumns}
                        shouldHideExport
                        screenPreferences={supplementalPrefs}
                        getData={this.getPaginatedSupplemental}
                        dealId={dealId}
                        tableData={supplementalLoanData}
                        downloadLoans={this.downloadLoans}
                        tableConfigItemId="2aee058e-28fb-4037-b2db-4ecf4ab03714"
                      />
                    </Paper>
                  </Fade>
                )}
                {(supplementalLoanCount === 0 || _.isEmpty(supplementalLoanData.data) || _.isEmpty(supplementalLoanData.data.loans)) && (
                  <Fade in={supplementalLoanCount === 0}>
                    <Paper elevation={4}>
                      <NoQuotes />
                    </Paper>
                  </Fade>
                )}
              </>
            )}
          </>
        )}
        <div style={{textAlign: "right", marginBottom:"-50px"}}>
          <div style={{float:"none", display:"inline-block", marginRight:"30px"}}>
            {isModifying && (
            <>
              <OptionsMenu buttonRenderer={this.buttonRenderer} options={this.getCalculatorOptions()}/>
              <AnalysisButton onClick={this.showAnalysisModal} />
            </>
            )}
          </div></div>
        <CompareLoansModal
                  dealId={dealId}
                  onClose={() => this.setState({ shouldShowCompareLoansModal: false })}
                  quoteType={this.getTabType(currentTab)}
                  loans={isModifying ? this.getExistingFinancing() || [] : this.getActiveTabLoanData(currentTab)}
                  isOpen={shouldShowCompareLoansModal && !isRefinance}
                  isModifying = {isModifying}
                  maxCount={isModifying ? 1 : 4}
                />
                <RefiCompareLoansModal
                  dealId={dealId}
                  onClose={() => this.setState({ shouldShowCompareLoansModal: false })}
                  quoteType={this.getTabType(currentTab)}
                  loans={this.getActiveTabLoanData(currentTab)}
                  isOpen={shouldShowCompareLoansModal && isRefinance}
                  history={this.props.history}
                  maxCount={4}
                />
                <QuoteCombineCompareAnalysisModal
                  isRefi={isRefinance}
                  isModifyDeal={isModifying}
                  hasSeniorAndMezzLoans={this.hasSeniorAndMezzLoans()}
                  dealId={deal.id}
                  isOpen={this.state.shouldShowAnalysisModal}
                  handleClose={this.closeAnalysisModal}
                  selectCombine={() => {
                    this.closeAnalysisModal();
                    this.showCombine();
                  }}
                  selectCompareAndCombine={() => {
                    this.closeAnalysisModal();
                    this.showCombine(true); // todo: this true param will be passed to the modal for weather or not it should include existing aggregate
                  }}
                  selectCompare={() => {
                    this.closeAnalysisModal();
                    this.showCompare();
                  }}
                />
                <CombineQuotesModal
                  dealId={dealId}
                  onClose={() => this.setState({ shouldShowCombineLoansModal: false })}
                  seniorLoans={this.getLoanData("comparableSeniorLoans").map(this.formatForCompare)}
                  mezzLoans={this.getLoanData("comparableMezzLoans").map(this.formatForCompare)}
                  isOpen={shouldShowCombineLoansModal}
                  isCompareAndCombine={this.state.isCompareAndCombine}
                />
                <LoanProceedsModal
                  scope= "deal"
                  dealId = {deal.id}
                  isOpen = {this.state.isLoanProceedsCalculatorOpen}
                  handleClose = {this.closeLoanProceedsCalculator}
                />
                <WhatIfModal 
                  isOpen = {this.state.isWhatIfCalculatorOpen}
                  handleClose = {this.closeWhatIfCalculator}
                  scope = {"pipelineDeal"}
                  seniorLoans={this.getLoanData("comparableSeniorLoans").map(this.formatForWhatIf)}
                  mezzLoans={this.getLoanData("comparableMezzLoans").map(this.formatForWhatIf)}
                  />
      </div>
    );
  }

  getExistingFinancing = () => {
    if(this.props.existingFinancing && this.props.existingFinancing.data){
      return this.props.existingFinancing.data.loans;
    }
  }
}

const mapStateToProps = ({ authentication, loan, deal, screenPreferences }) => ({
  authentication,
  dealMap: deal || {},
  seniorPrefs: screenPreferences.screen_pref.senior_loan_table,
  seniorLoanData: loan.loansByPreference.senior_loan_table || {},
  mezzPrefs: screenPreferences.screen_pref.mezz_loan_table,
  mezzLoanData: loan.loansByPreference.mezz_loan_table || {},
  supplementalPrefs: screenPreferences.screen_pref.supplemental_loan_table,
  supplementalLoanData: loan.loansByPreference.supplemental_loan_table || {},
  seniorLoanCount: loan.loanCounts.senior,
  mezzLoanCount: loan.loanCounts.mezz,
  supplementalLoanCount: loan.loanCounts.supplemental,
  comparableSeniorLoans: loan.loansByPreference.comparable_senior_loans || {},
  comparableMezzLoans: loan.loansByPreference.comparable_mezz_loans || {},
  comparableSupplementalLoans: loan.loansByPreference.comparable_supplemental_loans || {},
  redirectTo: deal.redirectTo,
  reload: deal.reloadDeal
});

export default compose(
  connect(mapStateToProps, {
    clearReload,
    getPipelineDealLoanCounts,
    getLoansByPreferenceAndLoanSeniority,
    getScreenPreferences,
    downloadDealQuotes,
    getWinningQuotes,
    closeDeal,
    cancelDealRefinance,
    cancelAddSupplemental,
    cancelModifyLoans,
    acknowledgeRedirect,
    killDeal,
    reviveDeal
  }),
  withStyles(materialStyles)
)(PipelineActiveDealQuotes);
